import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { CST_PRINTING_LIST_TYPE_XMLFile } from 'src/app/classes/const';
import { CUtilit } from 'src/app/classes/utilit';
import {CustomTableHeader, PrintingList, PrintingListInfoFormatData} from 'src/app/classes/json-interface';
import { AppToolbarService } from 'src/app/components/toolbar/services/app-toolbar.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DialogSelectStr } from 'src/app/components/dialog/dialogSelectStr/dialog-select-str';
import { MatDialog } from '@angular/material/dialog';
import { LoggedUserService } from '../../services/loged-user/loged-user.service';
import { ArmaServServerMethods } from '../../classes/ArmaServServerMethods';

const CST_PRINTING_TYPE_CUSTOMER = 'Customers';
const CST_PRINTING_TYPE_SITE = 'Sites';
const CST_PRINTING_TYPE_DRAWING = 'Drawing';
const CST_PRINTING_TYPE_ORDERS = 'Orders';
const CST_PRINTING_TYPE_DELIVERY_NOTE = 'Delivery notes';
const CST_PRINTING_TYPE_PRODUCTS = 'Products';
const CST_PRINTING_TYPE_SYPPLIERS = 'Suppliers';
const CST_PRINTING_TYPE_INVOICES = 'Invoices';
const CST_PRINTING_TYPE_STOCK_TAG = 'Stock tags';

@Component({
  selector: 'app-printing-list',
  templateUrl: './printing-list.component.html',
  styleUrls: ['./printing-list.component.css']
})
export class PrintingListComponent implements OnInit {

  @ViewChild('TablePaginator', { static: true }) HTML_TablePaginator!: MatPaginator;
  @ViewChild(MatSort, {static: true}) mTableSort!: MatSort;

  private mArrayPrintingListFormat: PrintingListInfoFormatData[] = []; // Correspond à la liste de format dispnible dans la printing list

  HTML_ListOptionValue: string = this.arrayTypePrintingLists[0]; // Correspond au type de list séléctionné
  HTML_FormatNameSelected?: string = '';  // Correspond au format de la printing list séléctionné

  HTML_ArrayCustomer: string[] = []; // Correspond à la liste des clients disponible
  HTML_CustomerSelected: string = this.mLoggedUser.customerCode ?? ''; //
  HTML_ArraySite: string[] = [];     // Correspond à la liste des chantiers disponible
  HTML_SiteSelected?: string = this.mLoggedUser.siteCode ?? '';    //

  HTML_BeginDate: Date | null = CUtilit.getBeginMonth();
  HTML_EndDate: Date | null = CUtilit.getEndMonth();

  HTML_TABLE_DATASOURCE: MatTableDataSource<any> = new MatTableDataSource<any>([]); // Correspond au données de la table
  HTML_TABLE_HEADER: string[] = [];                    // Correspond à l'entête de la table, string[] obligatoire, DOIT ETRE UNIQUE
  HTML_DynamicHeader: CustomTableHeader[] = [];

  mHTTPReqestInProgress: boolean = false;         // Indique si une requete est en cours d'execution // Fait le blockage des bouttons

  mTypePrintingList: number = 0;          //
  mStringTypePrintingList: string = '';   // Garde le nom du type de printing list, Utiliser pour crée le nom du fichier de téléchargement

  constructor(private mArmaServMethod: ArmaServServerMethods,
              private mLoggedUser: LoggedUserService,
              private mToolbar: AppToolbarService,
              private mDialog: MatDialog) { }

  ngOnInit() {
    this.mToolbar.toolbarPageTitle = 'Liste';
    this.HTML_TABLE_DATASOURCE.paginator = this.HTML_TablePaginator;
    this.HTML_TABLE_DATASOURCE.sort = this.mTableSort;
    this.updateArrayCustomer().catch(console.error);
    this.updateArraySite().catch(console.error);
    this.onListTypeChange(this.HTML_ListOptionValue); // Pour charger les formats
  }

  public onListTypeChange(newListType: string) {
    console.log('onListTypeChange', newListType);
    this.mStringTypePrintingList = newListType;
    switch (newListType) {
      case CST_PRINTING_TYPE_CUSTOMER:
        this.mTypePrintingList = CST_PRINTING_LIST_TYPE_XMLFile.LISTE_CLIENT;
        break;
      case CST_PRINTING_TYPE_SITE:
        this.mTypePrintingList = CST_PRINTING_LIST_TYPE_XMLFile.LISTE_CHANTIER;
        break;
      case CST_PRINTING_TYPE_DRAWING:
        this.mTypePrintingList = CST_PRINTING_LIST_TYPE_XMLFile.LISTE_PLANS;
        break;
      case CST_PRINTING_TYPE_ORDERS:
        this.mTypePrintingList = CST_PRINTING_LIST_TYPE_XMLFile.LISTE_CONTRAT;
        break;
      case CST_PRINTING_TYPE_DELIVERY_NOTE:
        this.mTypePrintingList = CST_PRINTING_LIST_TYPE_XMLFile.LISTE_BL;
        break;
      case CST_PRINTING_TYPE_PRODUCTS:
        this.mTypePrintingList = CST_PRINTING_LIST_TYPE_XMLFile.LISTE_PRODUIT;
        break;
      case CST_PRINTING_TYPE_SYPPLIERS:
        this.mTypePrintingList = CST_PRINTING_LIST_TYPE_XMLFile.LISTE_FOURNISSEUR;
        break;
      case CST_PRINTING_TYPE_INVOICES:
        this.mTypePrintingList = CST_PRINTING_LIST_TYPE_XMLFile.LISTE_FACTURE;
        break;
      case CST_PRINTING_TYPE_STOCK_TAG:
        this.mTypePrintingList = CST_PRINTING_LIST_TYPE_XMLFile.LISTE_ETIQSTOCK;
        break;
    }
    this.updateArrayFormat().catch(console.error);
  }

  /**
   * Lors du changement de format :
   *  - On actualise le tableau
   * @param newFormat ?
   */
  public onListFormatChange(newFormat: string) {
    this.HTML_FormatNameSelected = newFormat;
    this.updateTable().catch(console.error);
  }

  public async selectCustomer() {
    if (this.mHTTPReqestInProgress)
      return;
    const customerSelected = await DialogSelectStr.openDialog(this.mDialog, this.HTML_ArrayCustomer, 'Sélectionner le client');
    if (customerSelected)
      this.onListCustChange(customerSelected);
  }

  public resetCustomer() {
    if (this.mHTTPReqestInProgress)
      return;
    this.onListCustChange('');
  }

  /**
   * Lors du changement de client :
   *  - On actualise le tableau
   *  - On actualise le tableau de chantier
   * @param newCustomer ?
   */
  private onListCustChange(newCustomer: string) {
    // On fait rien si on selectionne le même client
    if (this.HTML_CustomerSelected == newCustomer)
      return;
    this.HTML_CustomerSelected = newCustomer;
    this.updateArraySite().catch(console.error);
    this.updateTable().catch(console.error);
  }

  public async selectSite() {
    if (this.mHTTPReqestInProgress)
      return;
    const siteSelected = await DialogSelectStr.openDialog(this.mDialog, this.HTML_ArraySite, 'Sélectionner le chantier');
    if (siteSelected)
      this.onListSiteChange(siteSelected);
  }

  public resetSite() {
    if (this.mHTTPReqestInProgress)
      return;
    this.onListSiteChange('');
  }

  /**
   * Lors du changement de chantier :
   *  - On actualise le tableau
   * @param newSite ?
   */
  onListSiteChange(newSite: string) {
    // On ne fait rien si on selectionne le même chantier
    if (newSite == this.HTML_SiteSelected)
      return;
    this.HTML_SiteSelected = newSite;
    // On verifie que le site donnée existe dans la liste, pour le cas ou la toolbar update la liste
    if (!this.HTML_ArraySite.includes(newSite)) {
      // ON vide le chantier sélécionné si il n'existe pas dans la liste
      this.HTML_SiteSelected = undefined;
    }
    this.updateTable().catch(console.error);
  }


  onDatePickerChange(event: MatDatepickerInputEvent<unknown>, endDate: boolean = false) {
    const eventValue = event.value;
    if (!eventValue)
      return console.error('onDatePickerChange: event value is null or unknown: ', eventValue);
    if (!(eventValue instanceof Date))
      return console.error('onDatePickerChange: event value is not a date: ', eventValue);
    if (endDate)
      this.HTML_EndDate = eventValue;
    else
      this.HTML_BeginDate = eventValue;
    this.updateTable().catch(console.error); // Si on change la date on doit mettre à jour le tablea
  }

  private async updateArrayCustomer() {
    this.HTML_ArrayCustomer = await this.mArmaServMethod.getListClient();
  }

  private async updateArraySite() {
    this.HTML_ArraySite = [];
    const paramCustomer = this.HTML_CustomerSelected ? this.HTML_CustomerSelected : '';
    this.HTML_ArraySite = await this.mArmaServMethod.getSiteForCustomer(paramCustomer);
    // On verifie que le site donnée existe dans la liste, pour le cas ou la toolbar update la liste
    if (!this.HTML_SiteSelected)
      return;
    if (!this.HTML_ArraySite.includes(this.HTML_SiteSelected)) {
      // ON vide le chantier sélécionné si il n'existe pas dans la liste
      this.HTML_SiteSelected = undefined;
    }
  }

  async updateArrayFormat() {
    this.HTML_FormatNameSelected = undefined; // Pour séléctionner none comme option
    this.mArrayPrintingListFormat = await this.mArmaServMethod.getListFormat(this.mTypePrintingList, this.mLoggedUser.isCustomerConnected);
    await this.updateTable();
  }

  /**
   * Actualise la table en fonction des parametres donnée
   *  - Format
   *  - Client
   *  - Chantier
   *  - Date debut
   *  - Date fin
   */
  async updateTable() {
    if (this.mHTTPReqestInProgress)
      return; // Bloquage si double update en cours
    this.mHTTPReqestInProgress = true;
    try {
      // Vidage tu tableau actuel
      this.clearTable();

      // Recuperer l'index du format pour l'envoyer sur armaServ
      const indexFormatSelected = this.getIDFormatFromSelectedFormatName();

      // Verification des parametre pour afficher le tablea
      if (indexFormatSelected == -1 || this.HTML_FormatNameSelected == undefined) {
        console.log('Format not selected');
        return;
      }

      const dataSnapResult = await this.mArmaServMethod.getPrintingList(
        this.mTypePrintingList,
        (this.HTML_SiteSelected == undefined ? '' : this.HTML_SiteSelected),
        (this.HTML_CustomerSelected == undefined ? '' : this.HTML_CustomerSelected),
        indexFormatSelected,
        this.HTML_BeginDate || new Date(),
        this.HTML_EndDate || new Date()
      );
      console.log('updateTable -> dataSnapResult', dataSnapResult);
      // Remplisage du tableau
      this.fillTable(dataSnapResult);
    } finally {
      this.mHTTPReqestInProgress = false;
    }
  }

  private clearTable() {
    this.HTML_TABLE_DATASOURCE.data = [];
    this.HTML_TABLE_HEADER = [];
    this.HTML_DynamicHeader = [];
  }

  /**
   * @param printingList data recuperer lors de l'envoie de la requete rest sur GetPrintingList
   */
  private fillTable(printingList: PrintingList) {
    if (!printingList)
      return console.log('No printinglist selected');
    this.HTML_DynamicHeader = printingList.Header;
    this.HTML_TABLE_HEADER = [];
    this.HTML_DynamicHeader.forEach(header => this.HTML_TABLE_HEADER.push(header.Id.toString()));
    this.HTML_TABLE_DATASOURCE.data = printingList.Tab;
  }

  public async download(fileExtension: string) {
    if (this.mHTTPReqestInProgress)
      return;
    try {
      this.mHTTPReqestInProgress = true;  // Pour bloquer les bouton download le temps de préparation du fichier
      const indexFormat = this.getIDFormatFromSelectedFormatName();
      if (indexFormat < 0)
        return console.error('No format selected');
      await this.mArmaServMethod.prepareAndDownloadPrintingList(
        fileExtension,
        this.mTypePrintingList,
        (this.HTML_SiteSelected == undefined ? '' : this.HTML_SiteSelected),
        (this.HTML_CustomerSelected == undefined ? '' : this.HTML_CustomerSelected),
        indexFormat,
        this.HTML_BeginDate || new Date(),
        this.HTML_EndDate || new Date()
      );
    } catch (e) {
      console.log(e);
    } finally {
      this.mHTTPReqestInProgress = false;
    }
  }

  private getIDFormatFromSelectedFormatName(): number {
    // Recuperer l'index du format pour l'envoyer sur armaServ
    let indexFormatSelected = -1;
    for (let i = 0; i < this.mArrayPrintingListFormat.length; i++) {
      if (this.mArrayPrintingListFormat[i].LibelleFormat == this.HTML_FormatNameSelected) {
        indexFormatSelected = this.mArrayPrintingListFormat[i].IDFormat;
        break;
      }
    }
    return indexFormatSelected;
  }

  public get htmlTableDataSource(): any {
    return {...this.mLoggedUser.classMediumBorder, ...this.mLoggedUser.classesMatTableBorder};
  }

  public get loggeduser() {
    return this.mLoggedUser;
  }

  public get arrayPrintingListFormat() {
    return this.mArrayPrintingListFormat;
  }

  /**
   * Retourne la constant qui n'est pas définit dans la classe
   * Pour l'utiliser niveau HTML
   */
  public get arrayTypePrintingLists(): string[] {
    if (this.mLoggedUser.isCustomerConnected)
      return [CST_PRINTING_TYPE_ORDERS];
    else
      return [
        CST_PRINTING_TYPE_CUSTOMER,
        CST_PRINTING_TYPE_SITE,
        CST_PRINTING_TYPE_DRAWING,
        CST_PRINTING_TYPE_ORDERS,
        CST_PRINTING_TYPE_DELIVERY_NOTE,
        CST_PRINTING_TYPE_PRODUCTS,
        CST_PRINTING_TYPE_SYPPLIERS,
        CST_PRINTING_TYPE_INVOICES,
        CST_PRINTING_TYPE_STOCK_TAG
      ];
  }
}
